export default __webpack_public_path__ + "static/media/icon_alibaba.a6690253.png";